/**
 * Sprint Redesign v1 · Phase 2+ · Baustein 2 (Do 03.09.2026, 15:15).
 *
 * Erweiterte Steckbrief-Daten für /andere-verstehen (Pro-Solo-Sicht):
 * Tonalität der Stimme, typische erste Impulse, Mimik-Muster, Brücken-Frage.
 *
 * Erstauslieferung Schritt 1: Hund + Eule vollständig.
 * Schritt 2 (separater Sprint): Katze + Biene mit gleichem Schema befüllen.
 */

export const STECKBRIEF_ERKENNUNG = {
  hund: {
    ready: true,
    tonalitaet:
      `Warm, ruhig, oft weich in den Rändern. Kürzere Sätze mit Rückfragen wie „Passt das für dich?" oder „Wie geht es dir damit?".`,
    erste_impulse: [
      `Zuerst schauen, wie es dem anderen gerade geht.`,
      `„Alles ok?"-Frage, wenn Stille im Raum ist.`,
      `Beziehung sichern, bevor die Sache angepackt wird.`,
    ],
    mimik: [
      `Freundlicher, oft nach vorne geneigter Kopf.`,
      `Direkter Blickkontakt mit weicher Umgebung um die Augen.`,
      `Wenn Konflikt: Rückzug im Gesichtsausdruck, aber Freundlichkeit bleibt.`,
    ],
    bruecken_frage: `Vielleicht jemand, der immer fragt, wie es dir geht — bevor er von sich erzählt?`,
  },
  eule: {
    ready: true,
    tonalitaet:
      `Präzise, ruhig, oft mit Pausen für den Gedanken. Sätze mit Strukturmarkern („erstens", „daraus folgt", „andererseits").`,
    erste_impulse: [
      `Kontext einordnen: „Worum geht es genau?"`,
      `Fakten sammeln, bevor eine Meinung geäußert wird.`,
      `Wenn die Logik fehlt: nachfragen, statt schnell zuzustimmen.`,
    ],
    mimik: [
      `Konzentrierter, oft leicht schräg gestellter Blick.`,
      `Sparsame Gestik — dafür längere Augen-Kontakte beim Zuhören.`,
      `Bei Ungereimtheiten: gehobene Augenbrauen, präzise Nachfrage.`,
    ],
    bruecken_frage: `Vielleicht jemand, der erst alle Fakten will, bevor er sich festlegt?`,
  },
  katze: {
    ready: true,
    tonalitaet:
      `Direkt, oft laut oder emotional betont. Sätze wie „Das seh ich anders." oder „Ich mach das jetzt so." — mit Nachdruck.`,
    erste_impulse: [
      `Sofort sagen, was gerade nicht passt — auch wenn's unbequem ist.`,
      `Optionen offen halten: „Ich schau's mir an, dann entscheide ich."`,
      `Bei Druck: Kontern statt zurückweichen.`,
    ],
    mimik: [
      `Ausdrucksstark: Augen weit, Augenbrauen sprechen mit.`,
      `Gestik groß, oft mit Händen und Kopf.`,
      `Bei Widerstand: verschränkte Arme, direkter Blick, keine Höflichkeitsfassade.`,
    ],
    bruecken_frage: `Vielleicht jemand, der offen sagt, was gerade nicht stimmt — auch wenn's unbequem wird?`,
  },
  biene: {
    ready: true,
    tonalitaet:
      `Klar, strukturiert, oft mit To-do-Sprache. Sätze wie „Konkret: erst A, dann B." oder „Was ist der nächste Schritt?".`,
    erste_impulse: [
      `Sofort in Umsetzung denken: „Was tun wir als Erstes?"`,
      `Aufgaben-Bild aufbauen: Wer macht was bis wann?`,
      `Bei Unklarheit: nachhaken, bis das Bild komplett ist.`,
    ],
    mimik: [
      `Konzentriert, oft leicht angespannt bei Unstrukturiertem.`,
      `Nickt bestätigend bei klaren Ansagen.`,
      `Bei fehlender Struktur: leises Kopfschütteln, Blick sucht den Fahrplan.`,
    ],
    bruecken_frage: `Vielleicht jemand, der immer als Erstes fragt „und was tun wir jetzt konkret?"?`,
  },
};

// Deutscher Slug ↔ englischer Profil-Key
export const SLUG_TO_KEY = {
  hund: "dog",
  eule: "owl",
  katze: "cat",
  biene: "bee",
};
